import Vue from 'vue'
import App from './App.vue'
import ElementUI, {Notification, MessageBox} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store/store'
import { i18n } from './api/i18n'
import SgmMonitor from './api/lib/monitor'
import { scReport } from '@/api/lib/report'
import { addLog } from '@/api/lib/addLog'
import './assets/styles/common.less'
import Fragment from 'vue-fragment'
import '@/api/rest/ajax-config'
import VueDND from 'awe-dnd'
import '../theme/index.css'
import {tracker,printTracker} from './utils/tracker/index'
import Print  from '@/utils/print/index.js'
import catchErr from '@/api/lib/catchErr.js'
import axios from 'axios';
import microApp from '@micro-zoe/micro-app'
axios.defaults.withCredentials = true


catchErr(Vue);

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Fragment.Plugin)
// checkbox实现拖动调整顺序
Vue.use(VueDND)
Vue.use(Print)
// Register a global custom directive called `v-focus`
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, {oldValue = true, value = true}) {
        // Focus the element
        if (value) {
            el.querySelector('input').disabled = false;
            el.querySelector('input').focus();
            el.querySelector('input').parentNode.classList.remove("is-disabled");
        } else {
            el.querySelector('input').disabled = true;
            // el.querySelector('input').parentNode.classList.add("is-disabled");
        }
    },
    update: function (el, {oldValue = true, value = true}) {
        // Focus the element
        if (value) {
            el.querySelector('input').disabled = false;
            el.querySelector('input').focus();
            el.querySelector('input').parentNode.classList.remove("is-disabled");
        } else {
            el.querySelector('input').disabled = true;
            // el.querySelector('input').parentNode.classList.add("is-disabled");
        }
    }
})

Vue.directive('overflow-tooltip', {
  bind(el, binding, vnode) {
    // 使用 nextTick 确保 DOM 已经渲染
    Vue.nextTick(() => {
      if (el.offsetWidth < el.scrollWidth) {
        // 内容溢出
        el.setAttribute('title', binding.value);
      }
    });
  }
});

Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox
Vue.prototype.$sgmMonitor = SgmMonitor
Vue.prototype.$tracker = tracker
Vue.prototype.$printTracker=printTracker
Vue.prototype.$scReport = scReport
Vue.prototype.$addLog = addLog
Vue.config.productionTip = false
// Vue2 不认识 <micro-app> 自定义元素，需告知其为原生标签，否则报「Unknown custom element / 找不到」
Vue.config.ignoredElements = ['micro-app']
// 注册 micro-app（定义 <micro-app> web component），必须在 new Vue 之前调用
microApp.start()
window.i18n = i18n
// 应用启动：把 cookie 里的用户信息一次性刷进 Vuex（userInfo 的单一来源）
store.dispatch('flushUserInfoFromCookie')
window.mainVm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')